<template>
    <ModalContainer :visible="visible" :loading="loading">
        <template v-slot:header>
            <button type="button" class="close" @click="$emit('close-subscription-type-modal')"><i class="las la-times"></i></button>
            <h4 class="modal-title">{{ $t('components.subscription_type.create')}}</h4>
        </template>
        <template v-slot:body>
            <SubscriptionTypeForm :subscription-type-prop="subscription_type" @change="onChangeSubscriptionType"></SubscriptionTypeForm>
        </template>

        <template v-slot:footer>
            <a class="btn btn-primary btn-lg btn-block"
               href=""
               @click.prevent.stop="createNewSubscriptionType(subscription_type)">
                <i class="las la-check"></i>
                {{ $t('components.subscription_type.create')}}
            </a>
        </template>
    </ModalContainer>
</template>

<script>
    import {SUBSCRIPTION_CATEGORY} from "../../common/constants";
    import {createSubscriptionType} from "../../api";
    import SubscriptionTypeForm from "../subscription_type/SubscriptionTypeForm";
    import ModalContainer from "./ModalContainer";
    export default {
        name: "AddSubscriptionTypeModal",
        props: {
            visible: {
                type: Boolean,
                required: true
            }
        },
        data: () => {
            return {
                loading: false,
                subscription_type: {
                    name: "",
                    category: SUBSCRIPTION_CATEGORY.NORMAL,
                    price: 0,
                    valid_for_days: 30,
                    unlimited_renewable: true,
                    months_renewable: 0,
                    unlimited_redeemable: false,
                    appointments_redeemable: 1,
                    valid_for_rates: []

                },
                errorMessage: ""
            }
        },
        components: {ModalContainer, SubscriptionTypeForm},
        methods: {
            async createNewSubscriptionType(subscriptionType) {
                this.loading = true;
                try {
                    const resultSubscriptionType =
                        await createSubscriptionType(
                            subscriptionType.name,
                            subscriptionType.category,
                            subscriptionType.price,
                            subscriptionType.unlimited_renewable,
                            subscriptionType.months_renewable,
                            subscriptionType.unlimited_redeemable,
                            subscriptionType.appointments_redeemable,
                            subscriptionType.valid_for_days
                        );
                    this.loading = false;
                    this.$emit('close-subscription-type-modal');
                    this.$nextTick(() => {
                        this.$router.push({ name: 'subscriptions_type_detail', params: { id: resultSubscriptionType.id }});
                    });

                } catch (e) {
                    this.loading = false;
                    console.log(e)
                }
            },
            onChangeSubscriptionType(subscription_type) {
                this.subscription_type = subscription_type;
            }
        }
    };
</script>
